import actionTypes from 'src/modules/redux/actionTypes'

export const setCartItemLoading = isLoading => ({
  type: actionTypes.SET_CART_ITEM_LOADING,
  payload: isLoading
})
